// @ts-nocheck
/* eslint-disable */
import { CHEVRON_LEFT_16, SHARE_FILLED_16, CLOSE_16, OVERFLOW_MENU_VERTICAL_FILLED, STAR } from "@sznds/icons";
import HeroHeader from "~/ui/heroheader";
import createHeaderButton from "~/ui/headerbutton";
import { addListener, makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import { altitudeProfile } from "~/util/providers/altitude";
import ContentOverlay from "~/content.overlay";
import { node, fragment, icon } from "~/util/dom";
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import Scene from "~/scene";
import MapInteractiveGeometry from "~/interactiveGeometry";
import InteractiveLineChart from "~/interactivelinechart";
import { store } from "~/state/store";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { getCreateLikeData, getUserTime, mapyboxAnalyticsSave, mymapsOpenFolder } from "~/util/mapybox";
import MyMapsMapyBoxItem from "~/ui/dialogs/mymaps-mapybox-item";
import { setCoordinates } from "~/state/map/state";
import { standardDistanceFormat } from "~/util/format";
import { getFolderData } from "~/util/providers/mapybox";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { createUserNote } from "~/ui/user-note/note";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import createSDSIcon from "~/ui/icon";
import { pathTypeToMapIcon } from "~/scene/common/icons";
import MyMapsBox from "~/ui/mymaps/box";
import MyMapsContextMenu from "~/es6/mymaps.contextmenu";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import { MYMAPS_SHARE } from "~/ui/sds-compatible-icons";
import MyMapsRemove from "~/ui/dialogs/mymaps-remove";
import MyMapsMoveItems from "~/ui/dialogs/mymaps-move-items";

/**
 * Signaly:
 * - path-activated
 * - path-deactivated
 */
Mapy.PathContent = class extends ContentOverlay {
	constructor() {
		super();
		this._contentName = "path";
		this._dom = {
			container: node("div", { id: "pathcontent", className: "pathcontent2" }),
			titleH1: node("h1"),
			iconSpan: node("span", { className: `icon` }),
		};
		this._state = null;
		this._data = null;
		this._allCoords = [];
		this._allSingleCoords = [];
		this._lineChartData = null;
		this._markerLayer = Scene.createLayerMarker();
		this._geometryLayer = Scene.createLayerGeometry("path-item");
		this._geometry = null;
		this._geometries = [];
		this._markers = [];
		this._interactiveGeometry = new MapInteractiveGeometry(this, {
			dragAndDrop: false,
		});
		this._interactive = null;
		this._text = null;
		this._userNote = null;
		this._contextMenu = null;
		this._lineChart = null;
		this._altitudeFrpc = null;
		this._showLabelInFrame = 0;
		this._logger = Mapy.getComponent("logger");
		this._editPopup = new PathEditPopup({
			cb: this._processSignal.bind(this)
		});
		this._resizeTO = {
			id: null,
			timeout: 100
		};
		this._const = {
			GEOM_RED_COLOR: "#f00",
			GEOM_GRAY_COLOR: "#6b7580"
		};
		this._3dlayer = null;

		this._buildCloseButton();

		addListener(this, "print-page", () => {
			this._userNote?.print();
			this._text?.print();
		});

		Scene.addListener("provider-changed", function(event) {
			var data = event.data;

			if (this.isActive() && data.name == "m3d") {
				if (this._3dlayer) {
					Scene.removeLayer(this._3dlayer);
					Scene.addLayer(this._3dlayer);
				}
				else {
					this._show3DGeometry();
				}
			}
		}, this);
	}

	destroy() {
		if (this._interactiveGeometry) {
			this._interactiveGeometry.destroy();
			this._interactiveGeometry = null;
		}

		if (this._userNote) {
			this._userNote.destroy();
		}

		this._userNote = null;
		this._markers = [];

		super.destroy();
	}

	activate() {
		if (this.isActive()) { return this; }

		Scene.addLayer(this._geometryLayer);
		Scene.addLayer(this._markerLayer);
		this._geometryLayer.enable();
		this._markerLayer.enable();
		window.addEventListener("resize", this, false);
		Mapy.SEO.set(_("path.seo"));
		makeEvent("path-activated", this);

		return super.activate();
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		if (this._3dlayer) {
			Scene.removeLayer(this._3dlayer);
			this._3dlayer.destroy();
			this._3dlayer = null;
		}

		this._geometryLayer.disable();
		this._markerLayer.disable();
		this._markerLayer.removeAll();
		this._geometryLayer.removeAll();
		Scene.removeLayer(this._geometryLayer);
		Scene.removeLayer(this._markerLayer);
		window.removeEventListener("resize", this, false);
		super.deactivate();
		makeEvent("path-deactivated", this);

		if (this._userNote) {
			this._userNote.destroy();
		}

		this._userNote = null;
		this._markers = [];

		this._interactiveGeometry.enabled = false;

		return this;
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);

		if (Mapy.getComponent("dimcurator") && this._data) {
			Mapy.getComponent("dimcurator").setState({ dim: this._data.id });
		}

		// pri skryti a zobrazeni se ztratilo tlacitko pro zavreni
		if (this._dom.closeDiv && this._dom.closeButton) {
			this._dom.closeDiv.appendChild(this._dom.closeButton);
		}

		this._markerLayer.enableInteraction();
		this._geometryLayer.enableInteraction();
		this._geometryLayer.getGeometriesList().forEach(g => {
			g.setOptions({
				color: this._const.GEOM_RED_COLOR
			});
		});

		return super.show();
	}

	hide() {
		if (Mapy.getComponent("dimcurator") && this._data) {
			Mapy.getComponent("dimcurator").setState();
		}

		this._markerLayer.disableInteraction();
		this._geometryLayer.disableInteraction();
		this._geometryLayer.getGeometriesList().forEach(g => {
			g.setOptions({
				color: this._const.GEOM_GRAY_COLOR
			});
		});

		return super.hide();
	}

	getState() {
		return {};
	}

	setState(state) {
		return new Promise(resolve => {
			let fromHistory = Mapy.getComponent("history").isFromHistory();

			this._showLabelInFrame = state.showLabel || 0;

			// set state
			if (state.likeData) {
				this._build(state);

				if (fromHistory && Scene.isM3dActive()) {
					Mapy.getComponent("history").save(true);
				}
			}

			super.setState(state);
			resolve();
		});
	}

	setTitle(title) {
		this._dom.titleH1.innerHTML = Mapy.Util.escapeHTML(title);
		this._dom.titleH1.title = this._dom.titleH1.textContent;
	}

	get activeGeomLayer() {
		return this._geometryLayer;
	}

	get markerLayer() {
		return this._markerLayer;
	}

	get markers() {
		return this._markers;
	}

	handleEvent(e) {
		if (e.type == "resize") {
			if (this._resizeTO.id) {
				clearTimeout(this._resizeTO.id);
				this._resizeTO.id = null;
			}

			this._resizeTO.id = setTimeout(() => {
				this._resizeTO.id = null;
				this._resizeLineChart();
			}, this._resizeTO.timeout);
		}
	}

	_build(state) {
		this._state = state;
		this._data = state.likeData;

		// upravy pro rucni mereni
		if (this._data.type == "measureRO") {
			this._data.data.data = [{
				route: this._data.data.points
			}];
			this._data.data.info = {
				totalLength: 0,
				trackType: this._data.data?.info?.trackType || "pesky",
			};
			this._data.type = "measure";
		}

		this._dom.container.innerHTML = "";

		this._buildGeometry();
		this._createContextMenu();
		this._buildHeader();
		this._buildStats();
		this._setLineChartData();
		this._resizeLineChart();
		this._setSEO();
		this._show3DGeometry();
	}

	_buildGeometry() {
		this._allCoords = [];
		this._allSingleCoords = [];

		if (this._data.data.data) {
			this._data.data.data.forEach(geom => {
				let coords = Scene.stringToCoords(geom.route);
				let geometry = Scene.createGeometry(Scene.GEOMETRY.POLYLINE, null, coords, {
					color: this._const.GEOM_RED_COLOR,
					width: 8,
					outlineOpacity: 0
				});

				this._geometryLayer.addGeometry(geometry);
				this._geometries.push(geometry);

				this._allCoords.push(coords);
				coords.forEach(coord => this._allSingleCoords.push(coord));
			});

			// nemame delku a mame vice jak 1 bod?
			if (this._data.data.info.totalLength === 0 && this._allSingleCoords.length > 1) {
				let distances = Mapy.Util.IP.countDistances(this._allSingleCoords);
				this._data.data.info.totalLength = distances.length ? distances[distances.length - 1] : 0;
			}

			this._interactiveGeometry.enabled = true;
			this._interactiveGeometry.start(this._data.data.info.totalLength || 0);
			this._interactiveGeometry.addCoords(0, this._allSingleCoords);

			this._geometry = Scene.createGeometry(Scene.GEOMETRY.POLYLINE, null, this._allSingleCoords);

			let startSpan = document.createElement("span");
			startSpan.classList.add("text");
			startSpan.innerHTML = _("track.detail.start");
			let marker = Scene.createMarkerWindy(this._allCoords[0][0], null, {
				type: Scene.VISUAL.MARKER_WINDY["BIG"],
				elm: startSpan,
				m3dData: {
					type: "route",
					value: "start"
				}
			});
			this._markers = [marker];
			this._markerLayer.addMarker(marker);

			let endSpan = document.createElement("span");
			endSpan.classList.add("text");
			endSpan.innerHTML = _("track.detail.end");
			let lastCoords = this._allCoords[this._allCoords.length - 1];
			marker = Scene.createMarkerWindy(lastCoords[lastCoords.length - 1], null, {
				type: Scene.VISUAL.MARKER_WINDY["BIG"],
				elm: endSpan,
				m3dData: {
					type: "route",
					value: "end"
				}
			});
			this._markers.push(marker);
			this._markerLayer.addMarker(marker);

			if (this._data && ((this._showLabelInFrame === 1 && this._data.usertitle) || (this._showLabelInFrame === 2 && (this._data.usertitle || this._data.title)))) {
				let coords = Scene.coordsFromWGS84(this._data.mark.lon, this._data.mark.lat);
				let marker = Scene.createMarkerMapyWindy(coords, null, { type: Scene.VISUAL.MARKER_WINDY.LITTLE });
				marker.setLabel(this._showLabelInFrame === 1 ? this._data.usertitle : this._data.usertitle || this._data.title);
				marker.setStyle("visibility", "hidden");
				marker.getContainer(el => {
					el.classList.add("hidden");
				});
				this._markers.push(marker);
				this._markerLayer.addMarker(marker);
			}

			if (!(("x" in this._state) && ("y" in this._state) && ("z" in this._state))) {
				let cz = this._geometry.computeCenterZoom(true);
				if (cz[1] == Infinity) {
					cz[1] = 17;
				}
				const [longitude, latitude] = cz[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: cz[1],
					animate: true,
				}));
				Mapy.getComponent("history").save();
			}

			if (CONFIG.inFrame) {
				this._geometryLayer.addEventListener("click", e => {
					Mapy.Util.openInNewWindow();
				});
				Scene.addListener("marker-click", () => {
					Mapy.Util.openInNewWindow();
				});
			}
		} else {
			this._geometry = null;
		}
	}

	_buildHeader() {
		const title = fragment();
		const date = getUserTime(this._data);

		this._dom.iconSpan.innerHTML = "";
		this._dom.iconSpan.appendChild(createSDSIcon({ symbol: pathTypeToMapIcon(Mapy.CUS.mapybox?.pathTypes && this._data.data?.info?.trackType ? this._data.data.info.trackType : "") }));
		title.appendChild(this._dom.iconSpan);
		this.setTitle(this._data.usertitle && this._data.usertitle.trim() != "" ? this._data.usertitle : this._data.title);
		title.appendChild(this._dom.titleH1);
		Mapy.CUS.mapybox?.date && title.appendChild(node("span", { textContent: Mapy.Util.dateFormat(new Date(date), "d. m. yyyy") }));

		this._header = new HeroHeader({
			poster: this._data.img ? Mapy.CDN.setSize(this._data.img, Mapy.CDN.SIZE_400_225) : "/img/header-placeholder.svg",
			title,
		});
		this._dom.container.appendChild(this._header.node);

		const backButton = createHeaderButton({
			icon: this._state.backTitle ? CHEVRON_LEFT_16 : CLOSE_16,
			innerHTML: this._state.backTitle || _("close"),
		});
		this._header.leftButtons.appendChild(backButton);
		backButton.addEventListener("click", event => {
			if (this._state.backAction) {
				this._state.backAction(event);
			} else {
				this._close();
			}
		});

		if (!this._data.id || this._data.foreign) {
			// ulozit
			const likeButton = createHeaderButton({
				icon: STAR,
				innerHTML: _("save"),
			});
			this._header.rightButtons.appendChild(likeButton);
			likeButton.addEventListener("click", () => {
				this._save();
			});
			likeButton.setAttribute("data-log-ignore", "1");
		}
		else if (this._data.id && !this._data.foreign) {
			// sdilet
			const shareButton = createHeaderButton({
				icon: MYMAPS_SHARE,
				innerHTML: _("action.share.title"),
			});
			this._header.rightButtons.appendChild(shareButton);
			shareButton.addEventListener("click", () => {
				this._sharePopupOpen();
			});
			shareButton.setAttribute("data-log-ignore", "1");

			if (!this._data.foreign && this._data.id) {
				const menuButton = createHeaderButton({
					icon: OVERFLOW_MENU_VERTICAL_FILLED,
					className: "more-options",
				});
				this._header.rightButtons.appendChild(menuButton);
				menuButton.addEventListener("click", () => {
					this._contextMenu.toggle();
				});
				this._dom.menuButton = menuButton;
			}
		}

		if (this._data.id) {
			if (this._data.foreign) {
				const frag = document.createDocumentFragment();

				frag.appendChild(createMyMapsSharing({
					data: this._data,
				}));

				if (this._data.description) {
					this._userNote = createUserNote({
						data: this._data,
						foreign: true,
					});

					frag.append(this._userNote.container);
				}

				this._dom.container.appendChild(frag);
			} else {
				this._buildMymapsBox();
				this._dom.container.appendChild(this._text.container);
			}
		}
	}

	_buildStats() {
		// statistiky
		let stats = node("ul", { className: "stats" });
		let distance = standardDistanceFormat(this._data.data.info.totalLength);

		[
			{ value: distance.distance, sub: distance.unit, sup: _("path.distance") }
		].forEach(item => {
			let li = node("li");
			let target = li;

			let sup = node("small", {
				innerHTML: item.sup,
				className: "sup"
			});

			let value = node("strong", {
				innerHTML: item.value
			});

			let sub = node("small", {
				innerHTML: item.sub,
				className: "sub"
			});

			target.appendChild(sup);
			target.appendChild(value);
			target.appendChild(sub);

			stats.appendChild(li);
		});

		this._dom.container.appendChild(stats);
	}

	_buildMymapsBox() {
		this._text = new MyMapsBox({
			isPremiumUser: isPremiumNoteUser(),
			noteVersion: getNoteVersion(),
			data: this._data,
			folder: {
				id: this._data.parent_id,
				title: this._data.parent_name,
			},
			onSignal: signal => {
				switch (signal.name) {
					case "delete":
						// jdeme do slozky
						mymapsOpenFolder(this._data.parent_id);
						break;

					case "like-move":
						this._data.parent_id = signal.folderId;
						this._data.parent_name = signal.folderTitle;
						break;

					default:
				}
			},
		});
	}

	_setLineChartData() {
		this._dom.lineChartCover = node("div", { className: "line-chart-cover" });
		this._dom.container.appendChild(this._dom.lineChartCover);

		if (this._data.data.info.sznAltitude) {
			this._lineChartData = this._data.data.info.sznAltitude;
			this._buildLineChart();
		}
		else {
			this._getAltitude();
		}
	}

	/**
	 * Ziskani vyskoveho profilu.
	 */
	_getAltitude() {
		this._abortAltitudeRequest();

		this._altitudeFrpc = altitudeProfile(Scene.coordsToString(this._allSingleCoords));
		this._altitudeFrpc.promise.then(data => {
			this._altitudeFrpc = null;
			this._lineChartData = data.altitude;
			this._buildLineChart();
		}, e => {
			this._altitudeFrpc = null;
		});

		return this._altitudeFrpc.promise;
	}

	/**
	 * Zrusime request pro vyskovy profil.
	 */
	_abortAltitudeRequest () {
		if (this._altitudeFrpc) {
			this._altitudeFrpc.request.abort();
			this._altitudeFrpc = null;
		}
	}

	_buildLineChart() {
		let totalLength = this._data.data.info.totalLength;
		let options = {
			width: (this._dom.container.offsetWidth ? this._dom.container.offsetWidth : 400) - 2 * 16
		};

		try { // kdyz dojdou spatna data z backendu, tak abychom nevyhnmili, ale zobrazili vsechno ostatni, krome vyskoveho profilu
			this._lineChart = new LineChart(this._lineChartData, totalLength, options);

			if (this._lineChart) {
				this._dom.lineChartCover.appendChild(this._lineChart.getContainer());
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e);
		}

		if (this._geometry && this._lineChart) {
			this._interactive = new InteractiveLineChart(this._lineChart, this._data.data.data.length > 1 ? this._allCoords : this._geometry, {
				...this._data.data.data.length > 1
				? {
					trackWithSpace: true,
					trackLength: this._data.data.info.totalLength,
				}
				: {},
				interactiveGeometry: this._interactiveGeometry,
			});
		}
	}

	_createContextMenu() {
		if (!this._data.id) return;

		this._contextMenu = new MyMapsContextMenu({
			clickCb: action => this._contextMenuAction(action),
			mapyboxItem: this._data,
			place: "path-detail",
		});

		this._contextMenu.parent = this._dom.container;
	}

	_getPopupData() {
		return {
			title: this._data.usertitle && this._data.usertitle != "" ? this._data.usertitle : this._data.title,
			id: this._data.id,
			description: this._data.description,
			public: this._data.public
		};
	}

	_contextMenuAction(action) {
		switch (action) {
			case "share":
				this._sharePopupOpen();
				break;

			case "save-as-new":
			case "edit":
				new MyMapsMapyBoxItem({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					likeData: this._data,
					mode: action === "edit"
						? "edit"
						: "save-as-new",
					folder: {
						id: this._data.parent_id,
						title: this._data.parent_name,
					},
					onSave: ({ likeData, folderData, trackType }) => {
						if (action === "edit") {
							Object.assign(this._data, likeData);
							this.setTitle(this._data.usertitle);

							if (trackType) {
								this._data.data.info.trackType = trackType;
								this._dom.iconSpan.innerHTML = "";
								this._dom.iconSpan.appendChild(createSDSIcon({ symbol: pathTypeToMapIcon(Mapy.CUS.mapybox?.pathTypes && this._data.data?.info?.trackType ? this._data.data.info.trackType : "") }));
							}

							if (this._data.parent_id !== folderData.id) {
								this._data.parent_id = folderData.id;
								this._data.parent_name = folderData.title;
							}

							if (this._text) {
								const prevElem = this._text.container.previousSibling;

								this._text.destroy();
								this._buildMymapsBox();
								prevElem.after(this._text.container);
							}
						} else {
							mapyboxAnalyticsSave({
								type: "path",
								note: !!likeData.description,
							});
						}

						// aktualizujeme batuzek
						const placesComp = Mapy.getComponent("places");

						Mapy.ProviderMapyBox.removeFolderFromCache(this._data.parent_id);
						placesComp.listRefreshData();
						placesComp.notifyLikeUpdate();

						if (action === "save-as-new") {
							Mapy.getComponent("dimcurator").setState({ dim: likeData.id }).loadData().then(() => {
								Mapy.getComponent("history").save();
							}, () => {});
						}
					},
				}).open();
				break;

			case "export":
				this._export();
				break;

			case "move-to-folder":
				new MyMapsMoveItems({
					item: this._data,
					ids: [this._data.id],
					moveFolders: [{
						id: this._data.parent_id,
						title: this._data.parent_name
					}],
					onSave: (folderId, folderTitle) => {
						this._data.parent_id = folderId;
						this._data.parent_name = folderTitle;

						if (this._text) {
							const prevElem = this._text.container.previousSibling;

							this._text.destroy();
							this._buildMymapsBox();
							prevElem.after(this._text.container);
						}
					},
				}).open();
				break;

			case "delete":
				new MyMapsRemove({
					data: this._data,
					onRemove: () => {
						const placesComp = Mapy.getComponent("places");

						Mapy.ProviderMapyBox.removeFolderFromCache(this._data.parent_id);
						placesComp.listRefreshData();
						placesComp.notifyLikeUpdate();

						this._back();
					},
				}).open();
				break;
		}
	}

	_back() {
		if (this._data.parent_id) {
			Mapy.getComponent("places").state = { mid: this._data.parent_id };
			Mapy.getComponent("mymaps").activate();
			Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("places"));
		}

		this._close();
	}

	_close() {
		Mapy.getComponent("path").deactivate();
		Mapy.getComponent("dimcurator").setState();
		Mapy.getComponent("history").save();
	}

	_processSignal(data) {
		switch (data.name) {
			case "updated":
				this.setTitle(this._editPopup.title);
				break;

			case "deleted":
				// zpatky do slozky
				this.deactivate();
				this._back();
				break;
		}
	}

	_export() {
		if (this._data.type == "measure") {
			this._exportMeasure();
		}
		else {
			this._exportPath();
		}
	}

	_exportMeasure() {
		new MyMapsExport({
			data: {
				name: "distancemeter",
				data: {
					criterion: "hand",
					geometry: Scene.coordsToString(this._allSingleCoords),
					title: this._data.usertitle || this._data.title,
				},
			},
		}).open();
	}

	_exportPath() {
		new MyMapsExport({
			data: {
				name: "path",
				data: {
					mid: this._data.id,
					title: this._data.usertitle || this._data.title,
				},
			},
		}).open();
	}

	_resizeLineChart () {
		if (this._lineChart) {
			this._lineChart.setData(undefined, undefined, { width: (this._dom.container.offsetWidth ? this._dom.container.offsetWidth : 400) - 2 * 16 });
		}
	}

	_sharePopupOpen() {
		const { mapset, provider } = store.getState().map;

		let sharePopup = new MyMapsShare({
			id: this._data.id,
			title: this._data.usertitle && this._data.usertitle != "" ? this._data.usertitle : this._data.title,
			type: this._data.type,
			url: `${location.protocol}//${location.host}/${mapset}?dim=${this._data.id}${provider === "m3d" ? "&m3d=1" : ""}`,
			public: this._data.public,
			like: true,
			showLabel: true
		}, cbData => {
			if (cbData.name == "popup-close") {
				this._data.public = cbData.public;
				if (this._data.public) {
					let logData = {
						text: "sdílet",
						origin: "my_maps",
						type: "acctivity"
					};
					this._logger.log("click", logData);
				}
			}
		});
		sharePopup.open();
	}

	_save() {
		const folderData = getFolderData();

		new MyMapsMapyBoxItem({
			isPremiumUser: isPremiumNoteUser(),
			noteVersion: getNoteVersion(),
			createData: getCreateLikeData({
				route: Scene.coordsToString(this._allSingleCoords),
				title: this._data.usertitle && this._data.usertitle != "" ? this._data.usertitle : this._data.title,
				description: this._data.description || "",
				...(this._data.type === "measure" || this._data.type === "path") && this._data.data?.info?.trackType
					? { trackType: this._data.data.info.trackType }
					: {},
			}, "path"),
			mode: "create",
			...folderData
				? {
					folder: folderData,
				}
				: {},
			onSave: ({ likeData: newLikeData }) => {
				Mapy.getComponent("logger").log("click", {
					type: "set",
					origin: "path",
				});
				mapyboxAnalyticsSave({
					type: "path",
					note: !!newLikeData.description,
				});
				Mapy.getComponent("dimcurator").setState({ dim: newLikeData.id }).loadData().then(() => {
					Mapy.getComponent("history").save();
				}, () => {});
			},
		}).open();
	}

	_setSEO() {
		let title = this._data.usertitle || this._data.title || "";
		title = _("path.seo") + (title ? ": " + title : "");
		let descr = _("path.seoDesc");

		Mapy.SEO.set(title, descr);

		if (Mapy.getComponent("print").mode === 3) {
			this._printMode3();
		}
	}

	/**
	 * metoda pro nastavení stránky, pokud je printMode = 3 - sdílení
	 */
	_printMode3 () {
		Mapy.getComponent("layout").setWidth(1);
		Mapy.getComponent("layout").getContent().classList.add("path-print");
	}

	_show3DGeometry() {
		if (!Scene.isM3dActive() || !this._data) return;

		let geometryLine = this._allSingleCoords.map(coord => {
			const wgs84 = coord.toWGS84();

			return [wgs84[0], wgs84[1]];
		});

		this._3dlayer = Scene.createLayerFree("path", [geometryLine], {
			lineOffset: [-0.19, 0, 0],
			outlineOffset: [-0.19, 0, 0]
		});
		Scene.addLayer(this._3dlayer);
	}
};
